import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { PaymentMethod } from '@entities/payment';
import { useCyberStore, PaymentPayee } from '@entities/tsp';
import { mtsPaymentMethodClickGtm, sbpPaymentMethodClickGtm } from '@shared/lib/gtm';
import { ChoiseMethod } from '@shared/ui/molecules';
import { paymentMethods } from '../../config/redesign/paymentMethods';
interface PaymentMethodSwitcherProps {
  payee: PaymentPayee;
}
const PaymentMethodSwitcher: FC<PaymentMethodSwitcherProps> = ({
  payee
}) => {
  const {
    paymentMethod,
    setPaymentMethod
  } = useCyberStore();
  const handleMethodClick = (type: PaymentMethod) => {
    if (paymentMethod === type) return;
    if (type === PaymentMethod.SBP) {
      sbpPaymentMethodClickGtm(payee.providerName);
    } else {
      mtsPaymentMethodClickGtm(payee.providerName);
    }
    setPaymentMethod(type);
  };
  return <PaymentMethodSwitcherWrapper>
      {paymentMethods.map(method => <ChoiseMethod key={method.type} size={{
      desktop: 'l',
      mobile: 's'
    }} variant={method.type === paymentMethod ? 'active' : 'default'} onClick={() => handleMethodClick(method.type)}>
          <IconWrapper>{method.icon}</IconWrapper>
        </ChoiseMethod>)}
    </PaymentMethodSwitcherWrapper>;
};
export default PaymentMethodSwitcher;
const PaymentMethodSwitcherWrapper = /*#__PURE__*/styled('div')({
  name: "PaymentMethodSwitcherWrapper",
  class: "p1jumq1y",
  propsAsIs: false
});
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1r5dysa",
  propsAsIs: false
});

require("./PaymentMethodSwitcher.linaria.module.css!=!../../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./PaymentMethodSwitcher.tsx");